import Vue from 'vue'
import Axios from 'axios'
import router from '../_router'
import cookieUtil from '../utils/cookieUtil'
import { filterPath } from '../utils/constant'
import store from './../_vuex'

if (process.env.NODE_ENV === 'production') {
  Axios.defaults.baseURL = 'https://hubeiconsmo.tothemax.cn/api/'
  // Axios.defaults.baseURL ='http://122.112.171.106:8100'
  // Axios.defaults.baseURL ='http://192.168.1.28:8100'
} else if (process.env.NODE_ENV === 'testing') {
  Axios.defaults.baseURL = 'https://hubeiconsmo.tothemax.cn/api/'
  // Axios.defaults.baseURL = 'http://122.112.171.106:8100'
  // Axios.defaults.baseURL ='http://192.168.1.28:8100'

} else {
  // Axios.defaults.baseURL = 'http://jgxt.slj.lyg.gov.cn/app'
  Axios.defaults.baseURL = 'https://hubeiconsmo.tothemax.cn/api/'
  // Axios.defaults.baseURL ='http://122.112.171.106:8100'
  // Axios.defaults.baseURL ='http://192.168.1.28:8100'
}

Axios.interceptors.request.use(config => {
  // try {
  //   const projectId = store.state.selectProject.projectId
  //   // if (projectId !== null) {
  //   //   config.headers['pId'] = projectId
  //   // }
  // } catch (e) {
  //   // to do sth
  // }
  if (cookieUtil.get('token')&&cookieUtil.get('token')!== null&&cookieUtil.get('token')!== 'undefined') {
    config.headers.Authorization ='Bearer '+cookieUtil.get('token')
  }else{
    console.log('没有token');
  }
  config.headers.Clientid = '428a8310cd442757ae699df5d894f051'
  config.headers.projectFlag = 420000
  return config
})

Axios.interceptors.response.use(res => {

  if (filterPath.indexOf(router.currentRoute.path) !== -1) {
    return res
  }
  if (res.data.code === 405) { // 未登陆码
    if (router.history.current.name !== 'login') {
      router.push({ name: 'login' })
    }
  }else if (res.data.code === 401||res.data.code === 403) { // 无权限码
    if (router.history.current.name !== 'login') {
      router.push({ name: 'login' })
    }
  }
  return res
}, err => {
  return Promise.reject(err)
})

Vue.prototype.$axios = Axios



// WEBPACK FOOTER //
// ./src/_axios/index.js